/** Plain-language labels for portal engagement analytics. */

export const AREA_LABELS: Record<string, string> = {
  dashboard: 'Dashboard',
  purchasing: 'Sales Orders',
  customers: 'Customers',
  calendar: 'Calendar',
  settings: 'Settings',
};

export const COMPANY_TYPE_LABEL: Record<string, string> = {
  // Poeton's own sites are supplier-typed; their trading partners are
  // customer-typed. Label them accordingly.
  supplier: 'Supplier site',
  customer: 'Customer site',
  helix: 'Helix',
};

export const ENGAGEMENT_LEVEL_LABEL: Record<string, string> = {
  strong: 'Strong',
  moderate: 'Moderate',
  low: 'Low',
  inactive: 'Inactive',
};

export const ENGAGEMENT_LEVEL_STYLE: Record<string, string> = {
  strong: 'bg-emerald-100 text-emerald-800',
  moderate: 'bg-amber-100 text-amber-800',
  low: 'bg-orange-100 text-orange-800',
  inactive: 'bg-slate-100 text-slate-600',
};

export const USAGE_STATUS_LABEL: Record<string, string> = {
  high: 'Regular use',
  medium: 'Some use',
  low: 'Rarely used',
};

export const USAGE_STATUS_COLOR: Record<string, string> = {
  high: '#10b981',
  medium: '#f59e0b',
  low: '#ef4444',
};
